export default __webpack_public_path__ + "static/media/commentsImage.9b99cb1f.svg";